<template>
  <a-config-provider :theme="antdThemeConfig">
    <div
      v-if="devEnvironment"
      class="environment-badge fixed left-1 text-center opacity-80 pointer-events-none"
      style="cursor: inherit; z-index: 999999">
      <div class="m-1 text-sm text-bold">
        {{ devEnvironment?.charAt(0) }} &nbsp;&nbsp;<font-awesome-icon
          :icon="['fas', 'circle-exclamation']"
          :beat="true" />
      </div>
    </div>
    <maintenance-overlay />
    <AdBlockDetectedModal />
    <TenantPickerModal />
    <UserProfileCompletionModal />
    <router-view />
  </a-config-provider>
</template>

<script>
import AdBlockDetectedModal from "@/components/UI/AdBlockDetectedModal.vue"
import MaintenanceOverlay from "@/components/UI/MaintenanceOverlay.vue"
import TenantPickerModal from "@/components/Tenant/TenantPickerModal.vue"
import UserProfileCompletionModal from "@/components/Telaryans/UserProfileCompletionModal.vue"
export default {
  inject: ["antdThemeConfig"],
  components: { AdBlockDetectedModal, MaintenanceOverlay, TenantPickerModal, UserProfileCompletionModal },
  data() {
    return {
      devEnvironment: process.env.VUE_APP_DEVELOPMENT_MODE
    }
  }
}
</script>
<style lang="scss">
body {
  background-color: var(--Gray-BG);
}
.corners-rounded-top {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.corners-rounded {
  border-radius: 4px;
}

.environment-badge {
  color: var(--Danger);
}
</style>
